import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { FetchDOIFromDatacite } from './FetchDOIFromDatacite';
import { FetchDOIFromICATPlus } from './FetchDOIFromICATPlus';
import { OpenAlexContext } from './OpenAlexContext';
import { isInstrumentDOI } from './utils/doi';
import { Loading } from './utils/Loading';

export function FetchAndDisplayDOI({
  doi,
  openAlexApiKey,
}: {
  doi: string;
  openAlexApiKey?: string;
}) {
  const isInstrument = isInstrumentDOI(doi);

  return (
    <OpenAlexContext.Provider value={openAlexApiKey}>
      {isInstrument ? (
        <Suspense fallback={<Loading />}>
          <FetchDOIFromDatacite doi={doi} isInstrument={isInstrument} />
        </Suspense>
      ) : (
        <ErrorBoundary
          fallback={
            <Suspense fallback={<Loading />}>
              <FetchDOIFromDatacite doi={doi} isInstrument={isInstrument} />
            </Suspense>
          }
        >
          <Suspense fallback={<Loading />}>
            <FetchDOIFromICATPlus doi={doi} />
          </Suspense>
        </ErrorBoundary>
      )}
    </OpenAlexContext.Provider>
  );
}
